<script>
import "swiper/swiper-bundle.css";
import appConfig from "../../../app.config";

import animationData from "@/components/widgets/lupuorrc.json";
import Lottie from "@/components/widgets/lottie.vue";
import axios from 'axios';

export default {
  page: {
    title: "Wizard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Wizard",
      items: [
        {
          text: "Forms",
          href: "/",
        },
        {
          text: "Wizard",
          active: true,
        },
      ],
      detailSeen:false,

      defaultOptions: { animationData: animationData },
    };
  },
  components: {
    lottie: Lottie
  },
  mounted(){
      this.getCountry();
        this.getDetail();
    // user profile img file upload
    document.querySelector("#profile-img-file-input").addEventListener("change", function () {
        var preview = document.querySelector(".user-profile-image");
        var file = document.querySelector(".profile-img-file-input").files[0];
        var reader = new FileReader();

        reader.addEventListener(
            "load",
            function () {
                preview.src = reader.result;
            },
            false
        );

        if (file) {
            reader.readAsDataURL(file);
        }
    });

    document.querySelectorAll(".form-steps").forEach(function (form) {

        // next tab
        form.querySelectorAll(".nexttab").forEach(function (nextButton) {
            var tabEl = form.querySelectorAll('button[data-bs-toggle="pill"]');
            tabEl.forEach(function (item) {
                item.addEventListener('show.bs.tab', function (event) {
                    event.target.classList.add('done');
                });
            });
            nextButton.addEventListener("click", function () {
                var nextTab = nextButton.getAttribute('data-nexttab');
                document.getElementById(nextTab).click();
            });
        });

        //Pervies tab
        form.querySelectorAll(".previestab").forEach(function (prevButton) {

            prevButton.addEventListener("click", function () {
                var prevTab = prevButton.getAttribute('data-previous');
                var totalDone = prevButton.closest("form").querySelectorAll(".custom-nav .done").length;
                for (var i = totalDone - 1; i < totalDone; i++) {
                    (prevButton.closest("form").querySelectorAll(".custom-nav .done")[i]) ? prevButton.closest("form").querySelectorAll(".custom-nav .done")[i].classList.remove('done'): '';
                }
                document.getElementById(prevTab).click();
            });
        });

        // Step number click
        var tabButtons = form.querySelectorAll('button[data-bs-toggle="pill"]');
        tabButtons.forEach(function (button, i) {
            button.setAttribute("data-position", i);
            button.addEventListener("click", function () {
                var getProgreebar = button.getAttribute("data-progressbar");
                if (getProgreebar) {
                    var totallength = document.getElementById("custom-progress-bar").querySelectorAll("li").length - 1;
                    var current = i;
                    var percent = (current / totallength) * 100;
                    document.getElementById("custom-progress-bar").querySelector('.progress-bar').style.width = percent + "%";
                }
                (form.querySelectorAll(".custom-nav .done").length > 0) ?
                form.querySelectorAll(".custom-nav .done").forEach(function (doneTab) {
                    doneTab.classList.remove('done');
                }): '';
                for (var j = 0; j <= i; j++) {
                    tabButtons[j].classList.contains('active') ? tabButtons[j].classList.remove('done') : tabButtons[j].classList.add('done');
                }
            });
        });
    });
  },

    methods: {

            getCountry(){
                axios.get(process.env.VUE_APP_API_BASEURL+'country')
                .then(response => {
                    if (response) {
                        this.listCOuntry=response.data;
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getState(country_id){
                axios.get(process.env.VUE_APP_API_BASEURL+'state/'+country_id)
                .then(response => {
                    if (response) {
                        this.listState=response.data;
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getDetail(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/create/4/64faf19fe2ee24256c882ed3853ea914cd7f77c443371b6ae0cf696a3aeaa06a')
                .then(response => {
                    if (response) {
                        if(response.data.status=='error'){
                            this.messageBag = response.data.msj;
                        }else{
                            this.detail = response.data;
                            console.log(this.detail.first_name);
                            this.detailSeen  = true;

                            this.firstName = this.detail.first_name;
                            this.lastName = this.detail.last_name;
                            this.emailAddress = this.detail.email;
                            this.phoneNumber = this.detail.phone_number;
                            this.nric = this.detail.nric;
                            this.address = this.detail.address;
                            this.postalCode = this.detail.postalcode;
                            this.city = this.detail.city;
                            this.state = this.detail.state_id;
                            this.country = this.detail.country_id;
                            this.dateOfBirth = this.detail.dob;
                            this.gender = this.detail.gender;

                            this.getState(this.country);
                        }
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            
            uploadFilefrontic(){
                this.frontic = this.$refs.frontic.files[0];
            },

            uploadFilebacktic(){
                this.backic = this.$refs.backic.files[0];
            },
            submitFile() {
                const formData = new FormData();
                formData.append(
                    'fontic', this.frontic
                );

                formData.append(
                    'backic', this.backic
                );
                const headers = { 'Content-Type': 'multipart/form-data' };
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/upload/nric/1', formData, { headers }).then((res) => {
                res.data.files; // binary representation of the file
                res.status; // HTTP status
                });
            }

            
        },

};
</script>

<template>
    <div class="row">
        <div class="col-xl-12">
            <!-- <input type="file" @change="uploadFile" ref="file"> -->
            <input id="profile-img-file-input" @change="uploadFilefrontic" ref="frontic" type="file" class="profile-img-file-input" accept="image/png, image/jpeg" >
            <input id="profile-img-file-input" @change="uploadFilebacktic" ref="backic" type="file" class="profile-img-file-input" accept="image/png, image/jpeg" >
            <button @click="submitFile">Upload!</button>
        </div>
        <div class="col-xl-6">


            <div class="card">
                <div class="card-header">
                    <h4 class="card-title mb-0">Progress Nav Steps sa</h4>
                </div><!-- end card header -->
                <div class="card-body form-steps">
                    <form action="#">
                        <div class="text-center pt-3 pb-4 mb-1">
                            <h5>Signup Your Account</h5>
                        </div>
                        <div id="custom-progress-bar" class="progress-nav mb-4">
                            <div class="progress" style="height: 1px;">
                                <div class="progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>

                            <ul class="nav nav-pills progress-bar-tab custom-nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-gen-info-tab" data-bs-toggle="pill" data-bs-target="#pills-gen-info" type="button" role="tab" aria-controls="pills-gen-info" aria-selected="true">1</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-info-desc" type="button" role="tab" aria-controls="pills-info-desc" aria-selected="false">2</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-warning-tab" data-bs-toggle="pill" data-bs-target="#pills-warning-desc" type="button" role="tab" aria-controls="pills-warning-desc" aria-selected="false">3</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-success-tab" data-bs-toggle="pill" data-bs-target="#pills-success" type="button" role="tab" aria-controls="pills-success" aria-selected="false">4</button>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="pills-gen-info" role="tabpanel" aria-labelledby="pills-gen-info-tab">
                                
                                <div class="tab-pane fade show active" id="pills-gen-info" role="tabpanel" aria-labelledby="pills-gen-info-tab">
                                            
                                    <div class="row gy-4">
                                        <div class="col-xxl-6 col-md-6">
                                            <div>
                                                <label for="basiInput" class="form-label">First Name</label>
                                                <input type="text" class="form-control" v-model="firstName">
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-6 col-md-6">
                                            <div>
                                                <label for="labelInput" class="form-label">Last Name</label>
                                                <input type="text" class="form-control" v-model="lastName">
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Email Address</label>
                                                <input type="email" class="form-control" v-model="emailAddress">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Phone Number</label>
                                                <input type="email" class="form-control"  v-model="phoneNumber">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">NRIC/Passport</label>
                                                <input type="text" class="form-control" v-model="nric">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-8">
                                            <div>
                                                <label for="labelInput" class="form-label">Address</label>
                                                <input type="text" class="form-control" v-model="address">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Zip/Postal</label>
                                                <input type="text" class="form-control" v-model="postalCode">
                                            </div>
                                        </div>

                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">City</label>
                                                <input type="text" class="form-control" v-model="city">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">State</label>
                                                <select v-model="state" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                                    <option v-for="(item, index) in listState" :key="index" :value="item.id" >
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Country</label>
                                                <select v-model="country" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                                    <option v-for="(item, index) in listCOuntry" :key="index" :value="item.id" >
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Date Of Birth</label>
                                                <input type="date" class="form-control" v-model="dateOfBirth">
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-md-4">
                                            <div>
                                                <label for="placeholderInput" class="form-label">Gender</label>
                                                <select v-model="gender" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                                    <option value="Male">
                                                        Male
                                                    </option>
                                                    <option value="Female">
                                                        Female
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-start gap-3 mt-4">
                                        <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-info-desc-tab"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Go to more info</button>
                                    </div>  
                                </div>
                            </div>
                            <!-- end tab pane -->

                            <div class="tab-pane fade" id="pills-info-desc" role="tabpanel" aria-labelledby="pills-info-desc-tab">
                                <div>
                                    <div class="text-center">
                                        <div class="profile-user position-relative d-inline-block mx-auto mb-2">
                                            <img src="@/assets/images/users/user-dummy-img.jpg" class="rounded-circle avatar-lg img-thumbnail user-profile-image" alt="user-profile-image">
                                            <div class="avatar-xs p-0 rounded-circle profile-photo-edit">
                                                <input id="profile-img-file-input" type="file" class="profile-img-file-input" accept="image/png, image/jpeg">
                                                <label for="profile-img-file-input" class="profile-photo-edit avatar-xs">
                                                    <span class="avatar-title rounded-circle bg-light text-body">
                                                        <i class="ri-camera-fill"></i>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <h5 class="fs-14">Add Image</h5>
                                        
                                    </div>
                                    <div>
                                        <label class="form-label" for="gen-info-description-input">Description</label>
                                        <textarea class="form-control" placeholder="Enter Description" id="gen-info-description-input" rows="2"></textarea>
                                    </div>
                                </div>
                                <div class="d-flex align-items-start gap-3 mt-4">
                                    <button type="button" class="btn btn-link text-decoration-none btn-label previestab" data-previous="pills-gen-info-tab" ><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back to General</button>
                                    <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-success-tab"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Submit</button>
                                </div>
                            </div>
                            <!-- end tab pane -->

                            <div class="tab-pane fade" id="pills-warning-desc" role="tabpanel" aria-labelledby="pills-info-warning-tab">
                                <div>
                                    <div class="text-center">
                                        
                                        
                                        <h5>31232131 !</h5>
                                        <p class="text-muted">333</p>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="pills-success" role="tabpanel" aria-labelledby="pills-success-tab">
                                <div>
                                    <div class="text-center">
                                        
                                        <div class="mb-4">
                                            <lottie
                                colors="primary:#0ab39c,secondary:#405189"
                                :options="defaultOptions"
                                :height="120"
                                :width="120"
                                />
                                        </div>
                                        <h5>Well Done !</h5>
                                        <p class="text-muted">You have Successfully Signed Up</p>
                                    </div>
                                </div>
                            </div>
                            <!-- end tab pane -->
                        </div>
                        <!-- end tab content -->
                    </form>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
    </div><!-- end row -->

                        
                        <!-- end row -->
    
</template>
